"use client";
import { LayoutProps } from '@/lib/definitions';
import { cn } from '@/lib/utils';
import { font_text_varela } from '../ui/fonts';


export default function layout({ children }: LayoutProps) {
    return (
        <div className={ cn('fixed inset-0 z-50 m-[0_!important] bg-slate-900 text-white flex flex-col items-center justify-center h-[100dvh] w-[100svw] text-2xl', font_text_varela.className) } dir='rtl'>
            <button className='bg-red-600 rounded mb-2 py-2 px-4 opacity-0 transition-opacity hover:opacity-100'
                onClick={ () => {
                    localStorage.clear();
                    location.reload();
                } }
            >איפוס</button>
            { children }
        </div>
    )
}